import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { picture_group } from "../../../../../public/assets";
import { selectLocale } from "../../../../locales/localeSlice";
import ServiceBubble from "../../General/ServiceBubble/ServiceBubble";

import {
  Picture_group,
  SubtitleText,
  TestimonialLeftContainer,
  TextHolder,
  TitleText,
} from "./TestimonialLeft.styles";

const TestimonialLeft = () => {
  const { t } = useTranslation();
  const currentLocale = useSelector(selectLocale);
  return (
    <TestimonialLeftContainer>
      <ServiceBubble
        label={t("reviewsSection.reviews", {
          lng: currentLocale,
        })}
        position="flex-start"
      />
      <TextHolder>
        <TitleText>
          {" "}
          {t("reviewsSection.title", {
            lng: currentLocale,
          })}
        </TitleText>
        <SubtitleText>
          {t("reviewsSection.subText", {
            lng: currentLocale,
          })}
        </SubtitleText>
        <Picture_group src="/assets/svg/avatarGroup_Testimonial.png" />
      </TextHolder>
    </TestimonialLeftContainer>
  );
};

export default TestimonialLeft;
